import { AlertTriangle } from 'lucide-react';

const MaintenanceBanner = () => {
  return (
    <div 
      data-testid="maintenance-banner"
      className="w-full bg-amber-500 text-black py-2 sm:py-3 px-4 text-center font-medium fixed top-0 left-0 right-0 z-[100]"
    >
      <div className="flex items-center justify-center gap-2">
        <AlertTriangle className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
        <span className="text-xs sm:text-sm md:text-base truncate">
          <strong>UNDER DEVELOPMENT</strong> — Registration, purchases, and trading unavailable.
        </span>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
